import ComingSoon from "../components/ComingSoon";

const ITEMS = [
  { kind: "Practical tool", title: "Ethical Impact Assessment template", body: "A pre-deployment review template for any AI system that affects people — stakeholders, harms, mitigations, decision rights." },
  { kind: "Practical tool", title: "Bias Audit Checklist", body: "A production-ready evaluation checklist with subgroup metrics, intersectional slicing, and report templates." },
  { kind: "Practical tool", title: "AI Governance Charter", body: "A board-level operating model: roles, decision rights, escalation paths, review cadence, and disclosures." },
  { kind: "Interactive framework", title: "Lifecycle Framework", body: "Six-stage view of an AI system with ethics checkpoints built into each stage." },
  { kind: "Interactive framework", title: "Stakeholder Framework", body: "A method for mapping people affected by an AI system — including those who never see it." },
  { kind: "Foundational principles", title: "Principles FAQ", body: "Plain-language answers to the questions most often raised in board reviews and procurement diligence." },
];

export default function Resources() {
  return (
    <ComingSoon
      kicker="Educational Resources"
      title="Frameworks, principles, and tools — built to be used, not admired."
      lede="A practitioner toolbox is in development: opinionated, well-tested templates that translate AI Act obligations into operating procedures. Each tool will be free to adapt under attribution."
      items={ITEMS}
    />
  );
}
